import {useEffect} from 'react';
import {useSearchParams} from 'react-router-dom';
import {draftHasContent} from '../lib/draftState';
import {KINDS} from '../lib/kinds';
import {draftStore, useDraft} from '../lib/newTellDraft';
import {Kind} from '../types';

// `/tell/new?plant=<label>&place=<id>&kind=<kind>`: a plant page or the memories prompt opens a
// new tell with those already filled. Applied once the stored draft has loaded, only into an
// untouched draft (a tell in progress wins), then stripped from the URL so Back or a reload
// does not apply it again.

const GUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const isKind = (v: string | null): v is Kind => KINDS.some(k => k.kind === v);

export function useTellPrefill() {
    const {draft, ready} = useDraft();
    const [params, setParams] = useSearchParams();
    const plant = params.get('plant');
    const place = params.get('place');
    const kind = params.get('kind');

    useEffect(() => {
        if (!ready || (plant === null && place === null && kind === null)) return;
        const d = draftStore.get().draft;
        if (!draftHasContent(d) && d.plants.length === 0 && d.placeId === null) {
            draftStore.patch({
                plants: plant && plant.trim() !== '' ? [plant.trim()] : [],
                placeId: place && GUID.test(place) ? place : null,
                kind: isKind(kind) ? kind : null,
                detail: null
            });
        }
        setParams({}, {replace: true});
    }, [ready, plant, place, kind, setParams]);

    return draft;
}
